import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link'
import Sidebar from '../data/aside'
import AsideComponent from '../components/Aside';
import State from '../data/State';
import Meta from '../components/posts/Meta'
import Comments from '../components/posts/Comments'
import SEO from '../components/SEO'


class Series extends React.Component {

  constructor() {
    super();

    const asideOpen = State.get('aside_open');
    this.state = {
      aside: asideOpen,
    };
    this.toggleAside = this.toggleAside.bind(this);
  }


  toggleAside() {
    State.set( 'aside_open', this.state.aside ? false : true );
    this.setState({ aside: this.state.aside ? false : true });
  }




  render() {

    const { markdownRemark: post } = this.props.data;
    const aside = Sidebar[post.frontmatter.series];

    let page_previous;
    let page_next;

    let asideData;

    // depending on the type of aside content, store them in an arry for easier access.
    if ( aside && aside.type === 'sections' ) {
      const arr = [];
      aside.data.map( sections => {
        sections.data.map( page => {
          arr.push(page);
        } )
      });
      asideData = arr;
    } else {
      asideData = aside.data;
    }


    // check if aside data is present and then loop over that.
    if ( asideData && asideData.length > 0 ) {
      const current_page = asideData.find( (page, index) => {
        return page.url === post.frontmatter.path;
      });
      const index = asideData.indexOf(current_page);
      if ( index != -1 ) {
        if ( index > 0 ) {
          page_previous = asideData[index-1];
        }
        if ( index < asideData.length ) {
          page_next = asideData[ index + 1 ];
        }
      }
    }


    return (
      <div className="series--component">

        <SEO data={ post.frontmatter } />

        { aside &&
          <AsideComponent data={ aside } open={ this.state.aside } onToggle={ this.toggleAside } />
        }


        <div className={`content-wrapper ${ this.state.aside ? 'has_sidebar' : '' }`}>

          { page_previous && <Link to={ page_previous.url } className="pagination" title={`Previous Page: ${page_previous.title}`}> &larr; </Link> }

          <div className="content markdown--content">

            <header>
              <h1>{ post.frontmatter.title }</h1>
            </header>

            <div dangerouslySetInnerHTML={{ __html: post.html }} />

            <Meta data={ post.frontmatter } series={aside.title} />
            <Comments data={ post.frontmatter } />

          </div>

          { page_next && <Link to={ page_next.url } className="pagination next" title={`Next Page: ${page_next.title}`}> &rarr; </Link> }

        </div>

      </div>
    )



  }


}


export default Series;



export const postQuery = graphql`
    query SeriesPostByPath($path: String!) {
      markdownRemark(frontmatter: { path: { eq: $path} }) {
        html
        frontmatter {
          path
          type
          title
          description
          tags
          series
          comments
          html_title
          image
          date(formatString: "MMMM DD, YYYY [at] hh:mm A")
          updated(formatString: "MMMM DD, YYYY [at] hh:mm A")
        }
      }
    }
  `


/*
              <p>Published on <strong>{ post.frontmatter.date }</strong></p>

*/



// WEBPACK FOOTER //
// ./src/global/templates/series.js